import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Grid, Header, Message } from "semantic-ui-react";

import Icon from "./Icon/index.js";

import LoadingView from "../views/LoadingView";

class LoadingGate extends React.Component {
  componentDidMount() {
    this.props.startLoad();
  }

  render() {
    const props = this.props;
    if (props.loading) {
      return <LoadingView message="Loading Spout..." />;
    } else if (!props.error) {
      return React.createElement(props.loadedComponent, {});
    } else {
      return (
        <div>
          <style>{`
          body > div,
          body > div > div,
          body > div > div > div.error-message {
            height: 100%;
            background: #4267bb !important; /* Old browsers */
            background: -moz-linear-gradient(45deg, #4267bb 0%, #17357a 100%) !important; /* FF3.6-15 */
            background: -webkit-linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important; /* Chrome10-25,Safari5.1-6 */
            background: linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4267bb', endColorstr='#17357a',GradientType=1 ) !important; /* IE6-9 fallback on horizontal gradient */
          }
        `}</style>
          <Grid
            textAlign="center"
            style={{ height: "100vh" }}
            verticalAlign="middle"
            className="error-message"
          >
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as="h2" inverted textAlign="center">
                <Icon icon="spout" /> &nbsp; Spout
              </Header>
              <Message error>
                There was an error loading Spout. Try refreshing!
              </Message>
            </Grid.Column>
          </Grid>
        </div>
      );
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    loading: props.isLoading(state),
    error: props.getError(state)
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    startLoad: () => dispatch(props.loadAction())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoadingGate)
);



// WEBPACK FOOTER //
// ./frontend/src/components/LoadingGate.js